import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
    name: 'AlertStatusPopup',
    components: {
        customModal
    },
    props: {
        Id: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            baseapi: process.env.VUE_APP_Service_URL,
            comments: "",
            resolveReason:"",      
            resolveReasons:[] 
            // resolveReasons:[
            //     {value:"Data Entry Error",label:"Corrected - Data Entry Error"},
            //     {value:"No Action Required",label:"No Action Required"},
            //     {value:"Investigator Notified",label:"Investigator Notified"},
            //     {value:"Query Raised to Site",label:"Query Raised to Site"},
            //     {value:"Other (Specify in comments)",label:"Other (Specify in comments)"}
            // ]
        }
    },
    mounted() {
        this.getAllAlertStatus()
    },
    methods: {
          async getAllAlertStatus() {
            const idtoken = store.getters.getIdToken;
            await axios
                .get(`${this.baseapi}/management/statusmaster/getall?StatusType=Alert`,{
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                   this.resolveReasons=response.data
                    
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async saveComments() {
            const idtoken = store.getters.getIdToken;
            await axios
                .put(`${this.baseapi}/forms/alert/changealerstatus?id=${this.Id}&status=${this.resolveReason}&comment=${this.comments}`, {},{
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    let detailstoemit={
                        id:this.Id,
                        comments:this.comments
                    }
                    this.$emit("applychanges",detailstoemit);
                    alert(this.$t("navigations.alert resolved successfully"))
                    this.$emit("closemodal");
                    this.$emit("refreshalerts");
                    
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        closeAssignModal() {
            this.$emit("closemodal");
            this.comments=""
            this.resolveReasons=[]
        }
    }

};